import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { formatPhoneInput } from '../../utils';


class ContractorFieldInfoForm extends React.Component {
  // static PropTypes = {
  //   projectId: PropTypes.string.isRequired,
  //   onSubmit: PropTypes.func.isRequired,
  //   contracts: PropTypes.array.isRequired,
  //   infoTypes: PropTypes.array.isRequired,
  //   fieldInfo: PropTypes.object.isRequired,
  // }
   
  getContractOptions () {
    return this.props.contracts.map(contract => {
      return {
        label: `${contract.regNumber} - ${contract.contractor}`,
        value: contract.id
      }
    });
  }

 getinfoTypeOptions () {
    return this.props.infoTypes.map(infoType => {
      return {
        label: infoType.desc,
        value: infoType.id
      }
    });
  }

  render () {

      const { fieldInfo }  = this.props;

      let canSubmit = false; 
      canSubmit = (fieldInfo.type!==undefined && fieldInfo.type!=='')&&(fieldInfo.email!==undefined && fieldInfo.email!=='')
      &&(fieldInfo.tel!==undefined && fieldInfo.tel!=='')&&(fieldInfo.address!==undefined && fieldInfo.address!=='')
      &&(fieldInfo.contractId!==undefined && fieldInfo.contractId!=='');

    return (
      <form className="modal-form blue-book-form" onSubmit={this.props.onSubmit}>
       
        <div className="control required">
          <label>Contract</label>
          {this.props.contracts.length
            ? <Select name=""
              value={fieldInfo.contractId}
              options={this.getContractOptions()}
              onChange={this.props.handleContractChange}
            />
            : <Select name=""
              value=""
              options={this.getContractOptions()}
              onChange={this.props.handleContractChange}
            />}
        </div>

          <div className="control required">
              <label>Info Type</label>
              <Select name="type"
                value={fieldInfo.type}
                options={this.getinfoTypeOptions()}
                onChange={this.props.handleInfoTypeChange}
              />
            </div>
        
        
        <div className="member-details two-cols">
          <div className="control required">
            <label>Phone</label>
            <input type="tel" name="tel"
              value={formatPhoneInput(fieldInfo.tel)}
              onChange={this.props.handleTelChange}
            />
          </div>

          <div className="control">
            <label>Alternate Phone</label>
            <input type="tel" name="telAlternate"
              value={formatPhoneInput(fieldInfo.telAlternate)}
              onChange={this.props.handleTelAltChange}
            />
          </div>

        </div>
         
        <div className="member-details two-cols">       

          <div className="control">
            <label>Fax</label>
            <input type="fax" name="fax"
              value={formatPhoneInput(fieldInfo.fax)}
              onChange={this.props.handleFaxChange}
            />
          </div>

          <div className="control required">
            <label>Email</label>
            <input type="email" name="email"
              value={fieldInfo.email}
              onChange={this.props.handleChange('email')}
            />
          </div>
          
        </div>

          <div className="control required">
            <label>Address</label>
            <input type="text" name="address"
              value={fieldInfo.address}
              onChange={this.props.handleChange('address')}
            />
          </div>

        


        <button className="btn-update" disabled={!canSubmit}>
          Save
        </button>
      </form>
    )
  }
}

ContractorFieldInfoForm.propTypes = {
  projectId: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  contracts: PropTypes.array.isRequired,
  infoTypes: PropTypes.array.isRequired,
  fieldInfo: PropTypes.object.isRequired
};

export default ContractorFieldInfoForm;